import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import StatisticsCard from '../StatisticsCard';
import LoadingSnackbar from '../../../../components/LoadingSnackbar';
import Board from './Board';
import {
  formatInitialSetupData,
  formatSubmissionData,
  includeDescriptionOfTotal
} from '../../../../helpers/dashboardDataFormatter';

const useStyles = makeStyles(theme => ({
  wrapper: {
    width: 'auto',
    margin: theme.spacing(-0.5)
  },
  card: {
    width: '100%',
    padding: '16px 16px 8px',
    margin: theme.spacing(0.5),
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.contrastText
  }
}));

function Content({ data, isLoading }) {
  const classes = useStyles();

  let submissions;

  let initialSetups;
  let printRequests;
  let insertBrackets;
  let flawedTrays;

  const formatSubmission = submissionData => {
    const formatted = {
      ...formatSubmissionData(submissionData)
    };

    const thirdParty = { ...formatted.live_data['3rd Party'] };

    return {
      ...formatted,
      description: '',
      live_data: {
        '3rd Party': {
          Total: thirdParty['3rd Party'],
          'Full Sets': thirdParty['3rd Party'],
          'Single Arch': thirdParty['Single Arch']
        },
        ON_HOLD: { ...formatted.live_data.ON_HOLD }
      }
    };
  };

  if (data.filtered_statistics) {
    submissions = formatSubmission(data.filtered_statistics.submissions);
    initialSetups = formatInitialSetupData(
      data.filtered_statistics.initial_setups,
      data.filtered_statistics.submissions
    );
    printRequests = includeDescriptionOfTotal(
      data.filtered_statistics.print_requests,
      data.filtered_statistics.initial_setups.total,
      'of Initial Setups'
    );
    insertBrackets = includeDescriptionOfTotal(
      data.filtered_statistics.insert_brackets,
      data.filtered_statistics.print_requests.total,
      'of Print Requests'
    );
    flawedTrays = includeDescriptionOfTotal(
      data.filtered_statistics.flawed_trays,
      data.filtered_statistics.submissions.total,
      'of All Submissions'
    );
  }

  return (
    <>
      <LoadingSnackbar show={isLoading} />
      <Grid container>
        <Grid container justifyContent="flex-start" className={classes.wrapper}>
          {submissions && (
            <StatisticsCard value={submissions} title={submissions.title} icon="submissions" />
          )}
          {initialSetups && (
            <StatisticsCard
              value={initialSetups}
              title={initialSetups.title}
              icon="initial_setups"
            />
          )}
          {printRequests && (
            <StatisticsCard
              value={printRequests}
              title={printRequests.title}
              icon="print_requests"
            />
          )}
          {insertBrackets && (
            <StatisticsCard
              value={insertBrackets}
              title={insertBrackets.title}
              icon="insert_brackets"
            />
          )}
          {flawedTrays && (
            <StatisticsCard value={flawedTrays} title={flawedTrays.title} icon="flawed_trays" />
          )}
          <Grid container item xs={12} md={8}>
            <Grid container item xs={12} direction="column" className={classes.card}>
              <Board statistics={data.statistics} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

Content.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object.isRequired,
  isLoading: PropTypes.bool
};

Content.defaultProps = {
  isLoading: false
};

export default Content;
